import { makeAutoObservable } from 'mobx'
import type { IActionsProps } from 'shared/ui'
import {
  type IResponseClickToText,
  type IResponseClickToTextNumber,
} from 'entities/ClickToText/api/type'
import { type Attachment } from 'entities/Attachment/model/Attachment'
import { Tag } from 'entities/Tags/model/Tag'
import type { ISendFromInfo } from 'entities/SendFrom'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { ClickToTextStatistics } from './ClickToTextStatistics'

export type IClickToText = ClickToText

export class ClickToText {
  id: number
  name: string
  number: IResponseClickToTextNumber
  message = ''
  shortUrl: string
  qrCode: string
  tags: Tag[]
  createdAt: string
  updatedAt: string
  createdBy: {
    id: number
    name: string
  }
  statistics: ClickToTextStatistics
  actionsProps: IActionsProps | null = null
  attachments: Attachment[] = []
  textInNumberProps: ISendFromInfo[] = []

  constructor(item: IResponseClickToText, private _entities: IEntitiesStore) {
    this.id = item.id
    this.name = item.name
    this.number = item.number
    this.message = item.message || ''
    this.shortUrl = item.short_url
    this.qrCode = item.qr_code
    this.tags = Array.isArray(item.tags) ? item.tags.map((tagResponse) => new Tag(tagResponse)) : []
    this.createdAt = item.created_at
    this.updatedAt = item.updated_at
    this.createdBy = item.created_by
    this.statistics = new ClickToTextStatistics({ clicks: item.clicks, leads: item.leads })
    this.attachments = []
    this.textInNumberProps = this.getTextInNumberProps(item)

    makeAutoObservable(this)
  }

  setActionsProps = (actionProps: IActionsProps) => {
    this.actionsProps = actionProps
  }

  getTextInNumberProps = (link: IResponseClickToText): ISendFromInfo[] => {
    const number = this._entities.numbersStore.getItem(link.number.id)

    return [
      {
        icon: 'inboxOpen',
        name: this.number.inbox_name,
        value: this.number.formatted_number,
        iconR: number?.is_aircall ? 'aircall' : undefined,
      },
    ]
  }

  get inboxId() {
    const inbox = this._entities.inboxesStore.getInboxByNumber(this.number.id)

    return inbox?.id
  }

  get isInvalid() {
    return false
  }
}
